import React from "react";

const WP_URL = process.env.REACT_APP_WP_URL || "https://mycover-up.fr";
const LOGO_URL = `${WP_URL}/react-app/logo-horizontal-couleur.webp`;
const PAYMENT_LOGOS_URL = `${WP_URL}/react-app/images/footer/payment-logos.png`;

function McuFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mcu-footer">
      <div className="mcu-subfooter">
        <div className="mcu-subfooter__inner">
          <div className="mcu-subfooter__col">
            <h3 className="mcu-subfooter__title">À propos</h3>
            <ul className="mcu-subfooter__list">
              <li>
                <a href={`${WP_URL}/decouvrir-mycoverup`} className="mcu-subfooter__link">
                  Notre histoire
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/fabrication-francaise-cache-clim`} className="mcu-subfooter__link">
                  Fabrication française
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/cache-clim-composite-aluminium`} className="mcu-subfooter__link">
                  Composite aluminium
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/decouvrir-mycoverup`} className="mcu-subfooter__link">
                  La brochure
                </a>
              </li>
            </ul>
          </div>

          <div className="mcu-subfooter__col">
            <h3 className="mcu-subfooter__title">Nos caches clim</h3>
            <ul className="mcu-subfooter__list">
              <li>
                <a href={`${WP_URL}/nos-realisations`} className="mcu-subfooter__link">
                  Nos réalisations
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/boutique`} className="mcu-subfooter__link">
                  Catalogue d&apos;inspirations
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/support-mycover-up`} className="mcu-subfooter__link">
                  Monter mon cache clim
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/boutique`} className="mcu-subfooter__link">
                  Bons plans
                </a>
              </li>
            </ul>
          </div>

          <div className="mcu-subfooter__col">
            <h3 className="mcu-subfooter__title">Infos pratiques</h3>
            <ul className="mcu-subfooter__list">
              <li>
                <a href={`${WP_URL}/support-mycover-up`} className="mcu-subfooter__link">
                  Support
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/espace-pro`} className="mcu-subfooter__link">
                  Espace professionnel
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/espace-client/`} className="mcu-subfooter__link">
                  Espace client
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/contact`} className="mcu-subfooter__link">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="mcu-subfooter__col">
            <h3 className="mcu-subfooter__title">Nos guides</h3>
            <ul className="mcu-subfooter__list">
              <li>
                <a
                  href={`${WP_URL}/guides-cache-clim/comment-choisir-le-bon-cache-climatiseur-pour-votre-exterieur`}
                  className="mcu-subfooter__link"
                >
                  Choisir un cache clim
                </a>
              </li>
              <li>
                <a
                  href={`${WP_URL}/guides-cache-clim/quel-materiau-choisir-cache-climatiseur`}
                  className="mcu-subfooter__link"
                >
                  Quel matériau choisir
                </a>
              </li>
              <li>
                <a
                  href={`${WP_URL}/guides-cache-clim/pourquoi-votre-pompe-a-chaleur-merite-aussi-un-cache-esthetique`}
                  className="mcu-subfooter__link"
                >
                  Protéger et embellir sa PAC
                </a>
              </li>
              <li>
                <a
                  href={`${WP_URL}/guides-cache-clim/installer-cache-climatiseur-etapes`}
                  className="mcu-subfooter__link"
                >
                  Installer un cache clim
                </a>
              </li>
              <li>
                <a
                  href={`${WP_URL}/guides-cache-clim/entretien-cache-climatiseur-exterieur`}
                  className="mcu-subfooter__link"
                >
                  Entretien cache clim
                </a>
              </li>
              <li>
                <a
                  href={`${WP_URL}/guides-cache-clim/cache-climatiseur-reglementation-copropriete`}
                  className="mcu-subfooter__link"
                >
                  Cache clim en copropriété
                </a>
              </li>
            </ul>
          </div>

          <div className="mcu-subfooter__col">
            <h3 className="mcu-subfooter__title">Infos légales</h3>
            <ul className="mcu-subfooter__list">
              <li>
                <a href={`${WP_URL}/expeditions-retours`} className="mcu-subfooter__link">
                  Livraison et remboursements
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/mentions-legales`} className="mcu-subfooter__link">
                  Mentions légales
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/politique-de-confidentialite`} className="mcu-subfooter__link">
                  Politique de confidentialité
                </a>
              </li>
              <li>
                <a href={`${WP_URL}/conditions-generales-de-vente`} className="mcu-subfooter__link">
                  CGV
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="mcu-bottombar">
        <div className="mcu-bottombar__inner">
          <a href={`${WP_URL}/`} className="mcu-bottombar__logo-link">
            <img
              src={LOGO_URL}
              alt="myCover'Up"
              className="mcu-bottombar__logo"
              width="538"
              height="112"
            />
          </a>

          <div className="mcu-bottombar__center">
            <div className="mcu-bottombar__social">
              <a
                href="https://www.facebook.com/mycoverup"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="mcu-bottombar__social-link"
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/mycoverup"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="mcu-bottombar__social-link"
              >
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
            </div>
            <p className="mcu-bottombar__copy">
              © {currentYear} myCover&apos;Up. Site réalisé par{" "}
              <a
                href="https://kapsloc.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="mcu-bottombar__credit"
              >
                Kapsloc
              </a>
            </p>
          </div>

          <div className="mcu-bottombar__payment">
            <img
              src={PAYMENT_LOGOS_URL}
              alt="Visa, Mastercard, Stripe, PayPal"
              width="173"
              height="25"
              className="mcu-bottombar__payment-img"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default McuFooter;
